import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core'
import { DOCUMENT } from '@angular/common'
import { timedPromise } from '../utilities/timedPromise'

@Injectable()
export class LoadingScreenService {
    private renderer: Renderer2

    constructor(rendererFactory2: RendererFactory2, @Inject(DOCUMENT) private document) {
        this.renderer = rendererFactory2.createRenderer(null, null)

        try {
            // hide the loader element (if not already removed by prerender)
            this.hideLoaderElement()

            // remove obsolete element after 1 sec. (sometimes the element blocks interaction on page)
            timedPromise(1000).then(() => this.removeLoaderElement())
        } catch (e) {
            console.log(e)
        }
    }

    private get loaderElement() {
        return this.document.querySelector('.loading-screen')
    }

    private hideLoaderElement() {
        if (this.loaderElement) {
            this.renderer.addClass(this.loaderElement, 'hidden')
        }
    }

    private removeLoaderElement() {
        if (this.loaderElement) {
            const parentElement = this.renderer.parentNode(this.loaderElement)

            if (parentElement) {
                this.renderer.removeChild(parentElement, this.loaderElement)
            }
        }
    }
}
